import api from "./api";

// Doc 0447 — Informes de atención. `from`/`to`: fechas LOCALES de la empresa (AAAA-MM-DD).
export const getReportSummary = (params) => api.get("/reports/summary", { params });
export const getReportTimeseries = (params) => api.get("/reports/timeseries", { params });
export const getReportBreakdown = (params) => api.get("/reports/breakdown", { params });
export const getReportTags = (params) => api.get("/reports/tags", { params });
export const getReportTransfers = (params) => api.get("/reports/transfers", { params });
export const getReportPending = (params) => api.get("/reports/pending", { params });
export const getReportCsat = (params) => api.get("/reports/csat", { params });
export const getReportCsatAgents = (params) => api.get("/reports/csat/agents", { params });
export const getReportKanban = (params) => api.get("/reports/kanban", { params });
export const getReportKanbanStuck = (params) => api.get("/reports/kanban/stuck", { params });
